import React, { useEffect } from "react";
import { RemoteParticipant as TwilioParticipant } from "twilio-video";
import { RemoteParticipantData } from "store/remote-participants/types";
import styles from "./FocusedParticipant.module.css";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { useFocusedParticipant } from "./useFocusedParticipant";
import { Icon } from "components/shared/icon/Icon";

interface FocusedParticipantProps {
  participant: TwilioParticipant;
  participantState: RemoteParticipantData;
}
export const FocusedParticipant: React.FC<FocusedParticipantProps> = ({
  participant,
  participantState,
}) => {
  const { muteAll } = useSelector((s: RootState) => s.remoteParticipants);
  const { videoRef, audioRef } = useFocusedParticipant(
    participant,
    participantState
  );
  const { audioOutput } = useSelector((s: RootState) => s.localTracks);

  useEffect(() => {
    if ((audioRef as any).current?.setSinkId) {
      (audioRef as any).current.setSinkId(audioOutput?.deviceId);
    }
  }, [audioOutput, audioRef]);

  return (
    <div className={`${styles["program-feed-container"]}`}>
      <div className={styles["participant-identity"]}>
        <span>
          {participantState.isSharingScreen
            ? `${participantState.identity}'s Screen`
            : "Production Preview"}
        </span>
        {!participantState?.audioIsEnabled && (
          <Icon className={styles["muted-participant"]} id="microphone"></Icon>
        )}
      </div>
      <div className={`${styles["video-element"]}`}>
        <video ref={videoRef} autoPlay={true} />
      </div>
      {!participantState.isSharingScreen && <audio
        ref={audioRef}
        autoPlay={true}
        muted={muteAll || !participantState?.audioIsEnabled}
      />}
    </div>
  );
};
